module.exports = __webpack_public_path__ + "img/product.ae6073bb.png";